import React from "react";
import Icon from "../../../components/AppIcon";
import { useTranslation } from "react-i18next";

const NotificationTable = ({
  notifications = [],
  sortConfig,
  onSort,
  onDelete, // ✅ أضفناها
}) => {
  const { t } = useTranslation();

  const formatNumber = (num) => {
    if (!num) return 0;
    if (num >= 1_000_000) return (num / 1_000_000).toFixed(1) + "M";
    if (num >= 1_000) return (num / 1_000).toFixed(1) + "K";
    return num;
  };

  const getSortIcon = (key) => {
    if (sortConfig?.key !== key) {
      return (
        <Icon
          name="ArrowUpDown"
          size={14}
          className="text-muted-foreground"
        />
      );
    }
    return sortConfig.direction === "asc" ? (
      <Icon name="ArrowUp" size={14} className="text-primary" />
    ) : (
      <Icon name="ArrowDown" size={14} className="text-primary" />
    );
  };

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden">
      {/* ================= Desktop ================= */}
      <div className="hidden lg:block overflow-x-auto">
        <table className="w-full">
          <thead className="bg-muted/50 border-b border-border">
            <tr>
              <th
                className="px-4 py-3 text-left cursor-pointer"
                onClick={() => onSort("title")}
              >
                <div className="flex items-center gap-2">
                  {t("title")}
                  {getSortIcon("title")}
                </div>
              </th>

              <th
                className="px-4 py-3 text-left cursor-pointer"
                onClick={() => onSort("text")}
              >
                <div className="flex items-center gap-2">
                  {t("text")}
                  {getSortIcon("text")}
                </div>
              </th>

              <th className="px-4 py-3 text-center">
                {t("image")}
              </th>

              <th
                className="px-4 py-3 text-center cursor-pointer"
                onClick={() => onSort("counter")}
              >
                <div className="flex items-center justify-center gap-2">
                  {t("counter")}
                </div>
              </th>

              {/* ✅ عمود الحذف */}
              <th className="px-4 py-3 text-center">
                {t("actions")}
              </th>
            </tr>
          </thead>

          <tbody className="divide-y divide-border">
            {notifications.map((notification) => (
              <tr
                key={notification.id}
                className="hover:bg-muted/30 transition"
              >
                <td className="px-4 py-4 text-sm">
                  {notification.title}
                </td>

                <td className="px-4 py-4 text-sm">
                  {notification.text}
                </td>

                <td className="px-4 py-4 text-center">
                  {notification.image && (
                    <img
                      src={notification.image}
                      alt=""
                      className="mx-auto h-10 w-10 rounded object-cover"
                    />
                  )}
                </td>

                <td className="px-4 py-4 text-center text-sm">
                  {formatNumber(notification.counter)}
                </td>

                {/* ✅ زر الحذف */}
                <td className="px-4 py-4 text-center">
                  <button
                    onClick={() => onDelete(notification.id)}
                    className="p-2 rounded-lg hover:bg-red-100 text-red-600 transition"
                  >
                    <Icon name="Trash2" size={18} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* ================= Mobile ================= */}
      <div className="lg:hidden divide-y divide-border">
        {notifications.map((notification) => (
          <div key={notification.id} className="p-4 space-y-3">
            <div className="text-sm font-medium text-foreground">
              {notification.title}
            </div>

            <div className="text-sm text-muted-foreground">
              {notification.text}
            </div>

            {notification.image && (
              <div className="flex justify-center">
                <img
                  src={notification.image}
                  alt=""
                  className="h-12 w-12 rounded object-cover"
                />
              </div>
            )}

            <div className="text-center text-sm font-medium">
              {t("counter")}: {formatNumber(notification.counter)}
            </div>

            {/* ✅ زر حذف بالموبايل */}
            <div className="flex justify-center pt-2">
              <button
                onClick={() => onDelete(notification.id)}
                className="flex items-center gap-2 px-4 py-2 text-sm text-red-600 bg-red-50 rounded-lg hover:bg-red-100 transition"
              >
                <Icon name="Trash2" size={16} />
                {t("delete")}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NotificationTable;
